export function snackbarProgressTimer(
  onProgress: (progress: number) => void,
  snackBarType: string,
  progressStart: number,
  duration: number,
  interval: number = 50
): () => void {
  let progress = progressStart;
  const step = (interval / duration) * 100;

  const timer = setInterval(() => {
    progress -= step;
    onProgress(Math.max(progress, 0));

    if (progress <= 0) {
      clearInterval(timer);
      console.log(`${snackBarType} snackbar progress complete!`);
    }
  }, interval);

  return () => clearInterval(timer);
}
